export type EventCBType = (...args: Array<any>) => void;

export type UnsubscribeFunctionType = () => void;

type EventEmitterEventsType = {
    [key: string]: Array<EventCBType>;
};

export class EventEmitter {
    private readonly events: EventEmitterEventsType;

    constructor() {
        this.events = {};
    }

    on(event: string, listener: EventCBType): UnsubscribeFunctionType {
        if (!Array.isArray(this.events[event])) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
        return () => this.removeListener(event, listener);
    }

    once(event: string, listener: EventCBType) {
        const tmpListener = (...args) => {
            this.removeListener(event, tmpListener);
            listener.apply(this, args);
        };
        this.on(event, tmpListener);
    }

    removeListener(event: string, cb: EventCBType): void {
        this.events[event] = cb ? this.events[event].filter(listener => listener !== cb) : [];
    }

    removeAllListeners(): void {
        Object.keys(this.events).forEach(event => {
            this.events[event] = [];
        });
    }

    emit(event: string, ...args: Array<any>): void {
        if (Array.isArray(this.events[event])) {
            this.events[event].forEach(listener => listener.apply(this, args));
        }
    }

    /** Returns the number of listeners for a given event name. */
    listenerCount(eventKey: string) {
        return this.events[eventKey]?.length ?? 0;
    }
}
